<template lang="pug" src="./template/LeaderboardSelector.pug"></template>
<style lang="stylus" src="./styles/LeaderboardSelector.styl" scoped></style>

<script>
export default {
    props: {
		leaderboard: {
			type: String,
			required: true,
		},
	},
    methods: {
        left() {
			this.$emit('left');
        },
		right() {
			this.$emit('right');
        },
    },
};
</script>
